import axios from "axios";
import helper from "helper";
export default axios.create({
    baseURL: `${helper.APIUrl}`,
    responseType: "json",
});
